export enum ScalingBar {
  Medium = 1.5,
  High = 2,
}
